export default __webpack_public_path__ + "static/media/print-icon.2fdb84b7.svg";